// extracted by mini-css-extract-plugin
export var deliveryRow = "_r7-a";
export var fixedHeight = "_r7-4";
export var freightLogo = "_r7-9";
export var fullWidth = "_r7-3";
export var priceColumn = "_r7-5";
export var radioSelected = "_r7-7";
export var radioUnselected = "_r7-6";
export var selectedOption = "_r7-2";
export var selectedOptionContainer = "_r7-1";
export var selection = "_r7-0";
export var tallSkeletonText = "_r7-8";